export const getBrowserLangAndCountry = (): [string, string] => {
  const isoCode = navigator.language;
  const [lang, country] = isoCode.split('-');
  return [lang, country ? country.toLowerCase() : lang];
};
